import {ValueObject} from '@s-ui/domain'

import {StringSharedValueObject} from '../../shared/ValueObjects/StringSharedValueObject.js'

export class RefundReservationOpinionTransactionsValueObject extends ValueObject {
  #opinion

  constructor({opinion}) {
    super()
    this.#opinion = opinion
  }

  static empty() {
    return new RefundReservationOpinionTransactionsValueObject({opinion: null})
  }

  static create({opinion}) {
    if (!opinion) return RefundReservationOpinionTransactionsValueObject.empty()
    return new RefundReservationOpinionTransactionsValueObject({
      opinion: StringSharedValueObject.create({value: opinion})
    })
  }

  get opinion() {
    return !this.#opinion ? this.#opinion : this.#opinion.value
  }

  get value() {
    return this.opinion
  }
}
